import axios from 'axios'
import { setAlert } from './alert'
import { 
    ADD_LOGIN,
    AUTH_LOGOUT,
    AUTH_SUCCESS
} from './types'

export const addLogin = (data, history) => async dispatch => {

    const endpoint = `${process.env.REACT_APP_AUTH_BASE_URL}/auth/pos-cabang/login`

    const myData = new FormData();
    myData.set('email', data.email);
    myData.set('password', data.password);

    try {
        const res = await axios({
            url: endpoint,
            method: "POST",
            data: myData,
            loading: true,
            headers: { 
              'Content-Type': 'multipart/form-data', 
              'Accept' : 'application/json', 
            }
        });

        sessionStorage.setItem("access_token", res.data.access_token);
        sessionStorage.setItem("role", res.data.role);
        sessionStorage.setItem("data", JSON.stringify(res.data.admin));

        dispatch({
            type: ADD_LOGIN,
            payload: res.data
        })

        dispatch({
            type: AUTH_SUCCESS,
            payload: res.data.admin
        })

        // dispatch(setAlert("Stage Added", "success"))
        history.push(`/dashboard`);
    } catch (error) {
        dispatch(setAlert("Email atau Password Salah", "error"))
        console.log(error)
        // dispatch({
        //     payload: { msg: error.response.statusText, status: error.response.status },
        //     type: STAGE_ERROR
        // })
    }
}

// export const authSuccess = (data) => {
//     dispatch({
//         type: ADD_LOGIN,
//         payload: res.data
//     })
// }

export const authLogout = () => {
    return {
      type: AUTH_LOGOUT
    }
}
  
export const logout = () => {
    return dispatch => {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('data');
      dispatch(authLogout());
      
    }
  }

export const authCheck = () => {
    return dispatch => {
        const access_token = sessionStorage.getItem('access_token')
        if (!access_token) {
            dispatch(logout())
        } else {
            const data = JSON.parse(sessionStorage.getItem('data'))
            if (!(data)) {
            dispatch(logout())
            } else {
                dispatch({
                    type: AUTH_SUCCESS,
                    payload: data
                })
            }
        }
    }
}
